'use client';

export default function GlobalError() {
  return (
    <html lang="en">
      <body
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          fontFamily: 'Inter, system-ui, sans-serif',
          backgroundColor: '#f5f5f5',
          margin: 0,
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: '480px', padding: '2rem' }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1f2937' }}>
            Something went wrong
          </h1>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
            Chronos encountered an unexpected error. This may be due to a deployment in progress.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '0.5rem 1.5rem',
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: 'pointer',
              fontSize: '0.875rem',
            }}
          >
            Retry
          </button>
        </div>
      </body>
    </html>
  );
}
